import { SortByStatusPipe } from '../../../../../_helpers/_pipes/sort-by-status.pipe';
import { ProfileConfirmModalComponent } from '../profile-confirm-modal/profile-confirm-modal.component';
import { SystemMaintenanceComponent } from '../../../../screens/system-maintenance/system-maintenance.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ChangeProfileEmailService } from './../../../../../_services/profile-settings/change-profile-email.service';
import { Component, OnInit } from '@angular/core';
import { UserDataService } from './../../../../../_services/data-services/user-data.service';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { ProfileConfirmModalService } from '../../../../../_services/profile-settings/profile-confirm-modal.service';
import { PolicyDataService } from '../../../../../_services/data-services/policy-data.service';
import _ from 'underscore';
import { PolicyDetailsService } from '../../../../../_services/my-insurance/policy-details.service';
import { FlagDataService } from '../../../../../_services/data-services/flag-data.service';
import { FlagResponse } from '@models/flag-response';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { BiometricAuthService } from '../../../../../_services/biometric-auth/biometric-auth.service';
import { Capacitor } from '@capacitor/core';
import { CompanyService } from '@services/my-insurance/company.service';
import { NavigationService } from '@services/navigation.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, SystemMaintenanceComponent, ProfileConfirmModalComponent, SortByStatusPipe],
  selector: 'app-profile-main',
  templateUrl: './profile-main.component.html',
  styleUrls: ['./profile-main.component.scss'],
})
export class ProfileMainComponent implements OnInit{
  user: any = {};
  confirmModal: boolean;
  PolicyArray: any;
  policyFlag = false;
  loaderLine = false;
  livoPolicy = false;
  as400Policy = false;
  allAffinityGroup = true;
  bankInfo: any = [];
  allLivoPolicy: any = [];
  policyId: any;
  bankAccountNumber: any;
  showBankAcccountMessage = false;
  acmicAllonEFT: boolean;
  maAllonEFT: boolean;
  eftEligibleFlag = false;
  isAutoPay: any;
  isPaperless: boolean;
  isPaymentus: boolean;
  isACH: boolean;
  showMessage: boolean;
  isAcmic: boolean;
  useBiometrics: boolean;
  bioStored: boolean;
  displayContactText = true;
  isAS400PolicyForDisplayText: boolean;
  existMaPolicy: boolean;
  showCompany: string;
  paperlessNotAvailable = false;

  constructor(
    private policyDataService: PolicyDataService,
    private profileConfirmModalService: ProfileConfirmModalService,
    private userDataService: UserDataService,
    private changeProfileEmailService: ChangeProfileEmailService,
    private navService: NavigationService,
    private storageService: StorageServiceObservablesService,
    private policyDetailsService: PolicyDetailsService,
    private flagDataService: FlagDataService,
    private acmicService: AcmicService,
    private bioMetricAuth: BiometricAuthService,
    private companyService: CompanyService
  ) {
    this.acmicAllonEFT = false;
    this.maAllonEFT = false;
    this.isAS400PolicyForDisplayText = false;
    this.existMaPolicy = false;
  }

  onRemoveAccount(selectedPolicyId, bankAccount) {
    this.bankAccountNumber = bankAccount;
    this.policyId = selectedPolicyId;
    this.confirmModal = true;
  }

  accountInfo() {
    return _.compact(
      _.pluck(_.pluck(this.PolicyArray, 'bankInfo'), 'accountNumber')
    );
  }

  onShowMessage() {
    this.showMessage = true;
  }

  closeModal() {
    this.showMessage = false;
  }

  ngOnInit() {
    this.isBioEnabled();
    this.loaderLine = true;
    this.isAcmic = this.acmicService.isACMIC();
    this.navService.saveCurrentUrl();
    this.companyService.$currentCompany.subscribe((company)=>{
      this.showCompany = company;
    })

    this.flagDataService.$flagDeatils.subscribe((response: FlagResponse) => {
      if (response) {
        this.isPaperless = response.paper;
        this.isAutoPay = response.eft;
        this.isPaymentus = response.pu;
        this.isACH = response.ach;
      }
    });

    this.userDataService.$userData.subscribe((userData) => {
      this.user = userData;
      this.policyDataService.$policyDetails.subscribe((policyResponse: any) => {
        if (policyResponse) {
          this.existMaPolicy = policyResponse.find(policy => 
            policy.company?.companyName !== "ACIC" && policy.company?.companyName !== "TW")
          this.paperlessNotAvailable = this.checkPaperlessEligibility(policyResponse);

          this.PolicyArray = policyResponse;
          this.displayContactText = this.PolicyArray[0].displayPhone;
          this.isAS400PolicyForDisplayText =
            policyResponse[0] &&
            policyResponse[0].policynumber.policyNumber.length === 6;
          let policyStatus = false;
          this.PolicyArray?.forEach((element, index) => {
            if (this.user) {
              if (
                this.allAffinityGroup &&
                !this.PolicyArray[index].hasAffinityGroup
              ) {
                this.allAffinityGroup = false;
              }

              if (
                element.policyFlags.isEft !== 'ENROLLED' &&
                (element.policyStatus === 'FUTURE' ||
                  element.policyStatus === 'ACTIVE') &&
                this.isAcmic
              ) {
                this.acmicAllonEFT = true;
              }

              if (
                element.policyFlags.isEft !== 'ENROLLED' &&
                (element.policyStatus === 'FUTURE' ||
                  element.policyStatus === 'ACTIVE') &&
                element.policynumber.policyNumber.length === 10 &&
                !this.isAcmic
              ) {
                this.maAllonEFT = true;
              }

              this.user?.bankAccountDetails?.forEach((policy) => {
                if (policy.accountHolderName) {
                  this.showBankAcccountMessage = true;
                }
              });

              const checkingInfo = this.user.bankAccountDetails
                ? this.user.bankAccountDetails.filter(
                    (x) => x.policyNumber === element.policynumber.policyNumber
                  )
                : [];
              if (checkingInfo.length > 0) {
                this.PolicyArray[index].bankInfo = checkingInfo[0];
                this.PolicyArray[index].bankStatus = true;
              } else {
                this.PolicyArray[index].bankInfo = {};
                this.PolicyArray[index].bankStatus = false;
              }
              if (
                element.policynumber.policyNumber.length !== 10 &&
                checkingInfo.length > 0
              ) {
                policyStatus = true;
              }
              if (element.policynumber.policyNumber.length !== 10) {
                this.PolicyArray[index].bankStatus = policyStatus;
                if (element.days_left_to_expire >= 0) {
                  this.as400Policy = true;
                }
              } else {
                // Commenting it as all the livo policies should get displayed under wallet section
                this.livoPolicy = true;
                if (
                  this.allLivoPolicy.findIndex(
                    (policy) =>
                      policy.policynumber.policyNumber ===
                      element.policynumber.policyNumber
                  ) === -1
                ) {
                  this.allLivoPolicy.push(element);
                }
              }
              this.policyFlag = true;
              this.loaderLine = false;
            }
          });

          this.bankInfo = this.accountInfo();
        }
      });
      if (this.PolicyArray && this.PolicyArray.length > 0) {
        this.checkAutopayEligibility(this.PolicyArray);
      }
    });

    this.profileConfirmModalService.$removeAccount.subscribe(
      (removeAccount) => {
        this.confirmModal = removeAccount;
      }
    );

    this.changeProfileEmailService.clearEmail();
  }

  checkPaperlessEligibility(policyArray): boolean {
    const isCommercialPolicy = (policy) =>
      policy?.policynumber?.policyNumber?.length === 6;

    const allCommercial = policyArray.every((policy) => isCommercialPolicy(policy));
    const noneEbillEligible = policyArray.every(
      (policy) => policy?.policyFlags?.isEbillEligible !== 'Y'
    );

    return allCommercial && noneEbillEligible;
  }

  checkAutopayEligibility(policyArray) {
    let eftEligiblePolicies = [];
    eftEligiblePolicies = policyArray.filter((policy) => {
      if (policy) {
        let dayDifference: any;
        const { effDate } = policy;
        if (effDate) {
          dayDifference = this.policyDetailsService.getDayDifference(effDate);
        }
        return (
          ((policy.policyFlags.isEftEligible === 'Y' &&
            policy.isNewPolicy &&
            dayDifference <= 0) ||
            (policy.policyFlags.isEftEligible === 'Y' &&
              !policy.isNewPolicy)) &&
          policy.policyStatus === 'ACTIVE' &&
          policy.billingDetails[0] &&
          (policy.billingDetails[0].badCheckCount == 'N' ||
            (this.isAcmic && policy.billingDetails[0].badCheckCount == 'Y')) &&
          policy.billingDetails[0].mortageeFlag == 'N' &&
          !policy.hasAffinityGroup &&
          !(
            policy.policyCancellationReason &&
            (policy.policyCancellationReason.toLowerCase() ==
              'pay - non-payment of insurance premium' ||
              policy.policyCancellationReason.toLowerCase() ==
                'fpd - failure to pay deposit') &&
            policy.policyFlags.isEft == 'UNENROLLED'
          )
        );
      }
    });
    if (eftEligiblePolicies.length > 0) {
      this.eftEligibleFlag = true;
    } else {
      this.eftEligibleFlag = false;
    }
  }


  async isBioEnabled() {
    if (Capacitor.isNativePlatform()) {
      const isBiometrics = (await this.bioMetricAuth.isBiometricAvailable())
        .isAvailable;
      if (isBiometrics) {
        this.useBiometrics = true;
        if (await this.bioMetricAuth.isBiometricStored()) {
          this.bioStored = true;
        }
      }
    }
  }

  saveBiometrics(event) {
    if (event.target.checked) {
      this.bioMetricAuth.saveCredentials(
        this.storageService.getUserFromStorage(),
        this.storageService.getBioPass()
      );
      this.storageService.setCookie(
        this.storageService.getUserFromStorage(),
        this.user.userDetails.firstName + ' ' + this.user.userDetails.lastName,
        '',
        true
      );
      this.bioStored = true;
    } else {
      this.bioMetricAuth.deleteCredentials();
      this.bioStored = false;
      this.storageService.deleteCookie();
    }
  }
}